import { client } from "../../client";
import { Address } from "../common";
import { AccountStatus } from "..";

export interface AccountSnippet {
  number: string;
  status: AccountStatus;
  properties: PropertySnippet[];
}
export interface PropertySnippet {
  id: string;
  address: Address;
}

export const getCustomerAccounts = (key: string, customerNumber: string) => {
  return client
    .get<{ results: AccountSnippet[] }>(`customers/${customerNumber}/accounts`)
    .then((response) => response?.data?.results);
};
